import buttonsetDirective from './directives/buttonsetDirective';
import datepicker from './directives/datepickerDirective';
import DateTimePickerDirective from './directives/datetimepickerDirective';
import dialog from './directives/dialogDirective';
import MultiselectDirective from './directives/multiselectDirective';
import customPopoverDirective from './directives/popoverDirective';
import rangeDatePicker from './directives/rangeDatePickerDirective';
import selectmenu from './directives/selectmenuDirective';
import sigoLoading from './directives/sigoLoadingDirective'
import DialogService from './services/dialogService';
import DialogSelectCtrl from './services/dialogs/select/dialog-select.controller';
import DialogDateCtrl from './services/dialogs/date/dialog-date.controller';
import AsignacionFormDirective from './directives/asignacion-form/asignacionFormDirectiva';
import AsignacionFormCtrl from './directives/asignacion-form/AsignacionFormCtrl';
import InputComentarioDirectiva from './directives/input-comentario/inputComentarioDirectiva';
import InputComentarioCtrl from './directives/input-comentario/inputComentarioCtrl';
import DialogsService from './services/dialogs/dialogs.service';
import DialogConfirmService from './services/dialog-confirm/dialogConfirmService';
import angular from 'angular';
import ScopeElementDirective from "./directives/scopeElementDirective";
require('angular-chosen-localytics/dist/angular-chosen');

/**
 * Modulo con componentes de la interfaz de usuario reutilizables para SiG-O
 */
const SigoUIModule = angular
    .module('sigo-ui', ['localytics.directives'])
    .provider("lang", LangProvider)
    .directive('sigoButtonset', buttonsetDirective)
    .directive('sigoDatepicker', datepicker)
    .directive('datetimepicker', DateTimePickerDirective)
    .directive('sigoDialog', dialog)
    .directive('sigoMultiselect', MultiselectDirective)
    .directive('sigoPopover', customPopoverDirective)
    .directive('sigoRangeDatePicker', rangeDatePicker)
    .directive('sigoSelectmenu', selectmenu)
    .directive('sigoLoading', sigoLoading)
    .service('dialogService', DialogService)
    .service('DialogsService', DialogsService)
    .controller('DialogSelectCtrl', DialogSelectCtrl)
    .controller('DialogDateCtrl', DialogDateCtrl)
    .controller('AsignacionFormCtrl', AsignacionFormCtrl)
    .directive('asignacionForm', AsignacionFormDirective)
    .controller('InputComentarioCtrl', InputComentarioCtrl)
    .directive('inputComentario', InputComentarioDirectiva)
    .service('dialogConfirmService', DialogConfirmService)
    .directive('scopeElement', ScopeElementDirective)
;

/**
 * Provider para configurar el idioma en todas las directivas
 * @constructor
 */
function LangProvider() {
    var _langKey = "";

    this.setLang = function (langKey) {
        _langKey = langKey;
    };

    this.$get = function () {
        return _langKey;
    }
}

export default SigoUIModule;